export const LINE_DESCRIPTION_MAX_LENGTH = 1000;

export function toLineDescription(value: string | null | undefined): string | undefined {
    const trimmed = value?.trim();
    return trimmed ? trimmed.slice(0, LINE_DESCRIPTION_MAX_LENGTH) : undefined;
}
